<template>
  <v-app>
    <Header />
    <v-content>
      <div id="content-wrapper">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-card class="elevation-12">
                <v-toolbar color="primary" dark flat>
                  <v-toolbar-title>Login</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-text-field
                      label="Username"
                      name="login"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="input.user"
                    ></v-text-field>

                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="input.pass"
                    ></v-text-field>

                    <!-- <v-col class="country">
                    <label for="ann-btn-url">Country: </label>
                    <select v-model="country" class="select-country">
                      <option></option>
                      <option value="au">Australia</option>
                      <option value="hk">Hong Kong</option>
                      <option value="my">Malaysia</option>
                      <option value="sg">Singapore</option>
                    </select>
                  </v-col> -->
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="submitLogin">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
// import LeftPanel from './components/LeftPanel';
// import Axios from 'axios';
import Footer from "./Footer";
import Header from "./LoginHeader";

export default {
  name: "App",

  data() {
    return {
      input: {
        user: "",
        pass: "",
      },
      country: "",
      success: false,
    };
  },

  computed: {
    currentView() {
      return this.$store.state.currentView;
    },
  },

  components: {
    // 'left-panel' : LeftPanel,
    Footer,
    Header,
  },

  watch: {
    currentView: function (val) {
      this.$router.push({ name: val }).catch(() => {});
    },
  },

  methods: {
    goTo(view) {
      this.$store.dispatch("loadView", view);
    },
    submitLogin() {
      let staticUser = "mc_support";
      let staticPass = "Maxicash@123";

      if (this.input.user == staticUser && this.input.pass == staticPass) {
        localStorage.setItem("isSuccess", "true");

        // Axios.post(process.env.VUE_APP_HOST_SERVER +'/api/country/connect', {
        //   "country" : this.country
        // }).then(() => this.$router.go('dashboard'))
        this.$router.go("dashboard");
      } else {
        alert("Wrong Username/Password");
      }
    },
  },
};
</script>

<style>
#content-wrapper {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #212121;
  font-weight: 300;
  padding: 20px 20px 100px 20px;
}

.dialog-screen-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.575);

  display: flex;
  justify-content: center;
  align-items: center;
}

/* common css */
.pt-0 {
  padding-top: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

/* Page headers */
.header.text-left {
  font-size: 26px;
  font-weight: normal;
}

/* Filter and create buttons */

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

.action-buttons button {
  color: white !important;
  letter-spacing: normal;
  text-transform: none;
}

.action-buttons .filter-btn {
  margin-right: 20px;
}

@media only screen and (max-width: 959px) {
  .action-buttons {
    justify-content: flex-start;
  }
}

.select-country {
  border: 1px solid black;
  border-radius: 5px;
  margin: 0px 10px;
  padding: 0px 10px;
}

.country {
  display: flex;
}
</style>
